import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {IDataField} from '../template.interface';
import {CancelIconButtonComponent, ConfirmIconButtonComponent, DialogHeaderComponent} from 'frontier/browserkit';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';

@Component({
  selector: 'app-data-field-selection-dialog',
  templateUrl: './data-field-selection-dialog.component.html',
  styleUrls: [],
  imports: [
    DialogHeaderComponent,
    MatFormField,
    MatSelect,
    MatOption,
    MatDialogActions,
    ConfirmIconButtonComponent,
    CancelIconButtonComponent,
    ReactiveFormsModule,
    MatLabel,
  ],
  standalone: true,
})
export class DataFieldSelectionDialogComponent implements OnInit {
  dataFields: IDataField[];
  selectionValue: FormControl<string> = new FormControl(null);

  constructor(
    public dialogRef: MatDialogRef<DataFieldSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataFieldSelectionDialogComponent
  ) {
  }

  ngOnInit(): void {
    return;
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectionValue.value ?? '');
  }

  onCancel(): void {
    this.dialogRef.close('');
  }
}
